import {BrickContext, ActionBrick, registerBrick } from 'olympe';

export default class CheckEnvironment extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(boolean)} setIsNode
     * @param {function(boolean)} setIsBrowser
     */
    update($, inputs, [setIsNode, setIsBrowser]) {
       const isNode = typeof process !== 'undefined' &&
           !!process.versions &&
           !!process.versions.node;
       setIsNode(isNode);
       setIsBrowser(!isNode);
    }
}

registerBrick('0192948092931d631323', CheckEnvironment);
